export const STATUS_STYLES = {
  Borrador: "bg-stone-200 text-stone-700 border-stone-300",
  Enviada: "bg-blue-100 text-blue-800 border-blue-200",
  Aprobada: "bg-[#49AC9A]/15 text-[#49AC9A] border-[#49AC9A]/30",
  Rechazada: "bg-[#ED1F26]/15 text-[#ED1F26] border-[#ED1F26]/30",
  Pendiente: "bg-[#FDC50D]/15 text-[#FDC50D] border-[#FDC50D]/30",
  Facturada: "bg-[#465B7F]/15 dark:bg-[#465B7F]/50 text-[#374A66] dark:text-slate-100 border-[#465B7F]/30",
  "En Proceso": "bg-blue-100 text-blue-800 border-blue-200",
  Completada: "bg-[#49AC9A]/15 text-[#49AC9A] border-[#49AC9A]/30",
  Entregada: "bg-stone-800 text-stone-100 border-stone-800",
  Pagada: "bg-[#49AC9A]/15 text-[#49AC9A] border-[#49AC9A]/30",
  "Pagada Parcial": "bg-[#FDC50D]/15 text-[#FDC50D] border-[#FDC50D]/30",
  Vencida: "bg-[#ED1F26]/15 text-[#ED1F26] border-[#ED1F26]/30",
  Cancelada: "bg-stone-200 text-stone-500 border-stone-300 line-through",
  Anulado: "bg-[#ED1F26]/15 text-[#ED1F26] border-[#ED1F26]/40 line-through",
  Anulada: "bg-[#ED1F26]/15 text-[#ED1F26] border-[#ED1F26]/40 line-through",
};

// Folios vinculados: OT en verde, Remisión en azul (identidad visual unificada).
export function FolioTag({ number, kind = "remision", testid, muted = "—" }) {
  if (!number) return <span className="text-[#98A2AE]" data-testid={testid}>{muted}</span>;
  const styles = kind === "ot"
    ? "bg-[#49AC9A]/15 text-[#2F6B39] border-[#49AC9A]/40"
    : kind === "quote"
    ? "bg-[#E0A82E]/15 text-[#8A5A00] border-[#E0A82E]/40"
    : "bg-[#465B7F]/15 text-[#374A66] border-[#465B7F]/40";
  return (
    <span data-testid={testid}
      className={`inline-flex items-center border px-2 py-0.5 rounded text-xs font-mono-data font-medium ${styles}`}>
      {number}
    </span>
  );
}

export const STATUS_LABELS = {
  Borrador: "Por enviar",
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-stone-200 text-stone-700 border-stone-300";
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center border px-2 py-0.5 text-xs uppercase tracking-wider font-mono-data ${cls}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
